export type Language = 'es' | 'en'

export const translations = {
  es: {
    nav: {
      home: 'Inicio',
      rainforest: 'Rainforest',
      boat: 'Boat Tours',
      gallery: 'Galería',
      reviews: 'Reseñas',
      faq: 'FAQ',
      book: 'Reserva Ahora',
    },
    hero: {
      headline: 'Vive Puerto Rico Como Un Local',
      subheadline:
        'Aventuras privadas en el rainforest y tours en bote inolvidables para quienes quieren vivir Puerto Rico de verdad.',
      ctaPrimary: 'Reserva por WhatsApp',
      ctaSecondary: 'Escríbenos en Instagram',
    },
    chooseAdventure: {
      rainforestTitle: 'Sweet & Salty Rainforest Experience',
      rainforestFeatures: [
        'Cascadas escondidas',
        'Piscinas naturales',
        'Guías locales',
        'Grupos pequeños',
        'Aventura en El Yunque',
      ],
      rainforestCta: 'Explorar Tour Rainforest',
      boatTitle: 'Blu Ocean Tours',
      boatFeatures: [
        'Tour privado en bote',
        'Cayo Icacos + Palominos',
        'Snorkeling',
        'Bebidas + snacks',
        'Colchón flotante',
        'Opción de Jet ski',
      ],
      boatCta: 'Explorar Tour en Bote',
    },
    aboutCollab: {
      headline: 'Dos Experiencias. Un Puerto Rico Que Nunca Vas A Olvidar.',
      description:
        'Sweet & Salty Puerto Rico y Blu Ocean Tours se unen para ofrecerte las experiencias de aventura más completas en Puerto Rico: una inmersión profunda en la selva tropical y un escape inolvidable en el Mar Caribe. Auténtico, local y premium.',
    },
    rainforestSection: {
      title: 'Sweet & Salty Rainforest Experience',
      description:
        'Explora El Yunque con guías locales que saben convertir una visita en una verdadera aventura puertorriqueña. Descubre cascadas escondidas, piscinas naturales, senderos tropicales y momentos que la mayoría de turistas nunca llegan a vivir.',
      features: [
        {
          title: 'Cascadas Escondidas',
          desc: 'Lugares secretos lejos de las multitudes.',
        },
        {
          title: 'Piscinas Naturales',
          desc: 'Sumérgete en aguas cristalinas de la montaña.',
        },
        {
          title: 'Cultura Local',
          desc: 'Aprende sobre la historia y flora de la isla.',
        },
        {
          title: 'Grupos Pequeños',
          desc: 'Atención personalizada y ambiente íntimo.',
        },
      ],
      cta: 'Reserva por WhatsApp',
    },
    bluOceanSection: {
      title: 'Blu Ocean Tours',
      description:
        'Desde Fajardo, Blu Ocean Tours te lleva a descubrir Cayo Icacos y Palominos en una experiencia privada en bote para hasta 6 personas. Disfruta música, snorkel, bebidas, snacks, colchón flotante, aguas cristalinas y opción de jetski.',
      features: [
        {
          title: 'Bote Privado',
          desc: 'Exclusivo para ti y tu grupo (hasta 6).',
        },
        {
          title: 'Icacos + Palominos',
          desc: 'Visita los cayos más hermosos del este.',
        },
        {
          title: 'Todo Incluido',
          desc: 'Bebidas, snacks, snorkel y colchón flotante.',
        },
        {
          title: 'Opción de Jet Ski',
          desc: 'Añade adrenalina a tu día en el mar.',
        },
      ],
      cta: 'Reserva Blu Ocean Tour',
    },
    whyBookUs: {
      title: '¿Por Qué Reservar Con Nosotros?',
      cards: [
        'Guías locales expertos',
        'Experiencias 100% privadas',
        'Locaciones reales de Puerto Rico',
        'Perfecto para turistas y locales',
        'Ideal para parejas, familias y cumpleaños',
        'Reserva fácil por WhatsApp o Instagram',
      ],
    },
    clientRatings: {
      title: 'Cómo Nos Califican Nuestros Clientes',
      subtitle:
        'Lee las reseñas reales de quienes ya vivieron la experiencia con cada marca.',
      sweetSalty: 'Reseñas de Sweet & Salty',
      bluOcean: 'Reseñas de Blu Ocean',
    },
    packages: {
      title: 'Nuestros Paquetes',
      rainforest: {
        title: 'Rainforest Experience',
        features: [
          'Opción privada / grupo pequeño',
          'Selva tropical El Yunque',
          'Cascadas y experiencia local',
        ],
        cta: 'Consultar disponibilidad',
      },
      boat: {
        title: 'Blu Ocean Tours',
        features: [
          'Tour privado en bote',
          'Hasta 6 personas',
          '5 horas de duración',
          'Icacos + Palominos',
          'Bebidas, snacks, snorkel, colchón',
          'Opción de Jet ski disponible',
        ],
        cta: 'Consultar disponibilidad por WhatsApp',
      },
    },
    reviews: {
      title: 'Lo Que Dicen Nuestros Invitados',
      items: [
        'La mejor experiencia que tuvimos en Puerto Rico.',
        'Nuestro guía nos hizo sentir seguros, bienvenidos y maravillados.',
        'Blu Ocean Tours fue lo mejor de nuestro viaje.',
        'Un día perfecto con amigos, todo estaba incluido.',
      ],
    },
    faq: {
      title: 'Preguntas Frecuentes',
      items: [
        {
          q: '¿Cómo reservo?',
          a: 'Puedes reservar fácilmente enviándonos un mensaje por WhatsApp o un DM por Instagram.',
        },
        {
          q: '¿De dónde salen los tours?',
          a: 'Los tours en bote salen de Fajardo. Para el Rainforest, coordinaremos el punto de encuentro en El Yunque.',
        },
        {
          q: '¿Es privado?',
          a: 'Sí, Blu Ocean Tours es 100% privado (hasta 6 personas). Sweet & Salty ofrece opciones privadas y de grupos pequeños.',
        },
        {
          q: '¿Qué incluye el tour en bote?',
          a: 'Bote, capitán, bebidas, snacks, equipo de snorkel, colchón flotante, música, sombrilla de playa y flotadores.',
        },
        {
          q: '¿Necesito experiencia para el snorkel o jet ski?',
          a: '¡No! Nuestros guías te enseñarán todo lo que necesitas saber para disfrutar de forma segura.',
        },
        {
          q: '¿Qué debo llevar?',
          a: 'Traje de baño, toalla, protector solar (reef-safe), gafas de sol y muchas ganas de pasarla bien.',
        },
      ],
    },
    finalCta: {
      headline: 'Tu Historia En Puerto Rico Empieza Aquí.',
      btnWhatsapp: 'Reserva por WhatsApp',
      btnInstagram: 'Escríbenos en Instagram',
      btnWebsite: 'Ver ofertas de Blu Ocean',
    },
    footer: {
      rights: 'Todos los derechos reservados.',
      locationBoat: 'Fajardo, Puerto Rico',
      locationRainforest: 'El Yunque, Puerto Rico',
    },
  },
  en: {
    nav: {
      home: 'Home',
      rainforest: 'Rainforest',
      boat: 'Boat Tours',
      gallery: 'Gallery',
      reviews: 'Reviews',
      faq: 'FAQ',
      book: 'Book Now',
    },
    hero: {
      headline: 'Experience Puerto Rico Like a Local',
      subheadline:
        'Private rainforest adventures and unforgettable boat tours designed for travelers who want more than a regular tour.',
      ctaPrimary: 'Book on WhatsApp',
      ctaSecondary: 'Message us on Instagram',
    },
    chooseAdventure: {
      rainforestTitle: 'Sweet & Salty Rainforest Experience',
      rainforestFeatures: [
        'Hidden waterfalls',
        'Natural pools',
        'Local guides',
        'Small groups',
        'El Yunque adventure',
      ],
      rainforestCta: 'Explore Rainforest Tour',
      boatTitle: 'Blu Ocean Tours',
      boatFeatures: [
        'Private boat tour',
        'Cayo Icacos + Palominos',
        'Snorkeling',
        'Drinks + snacks',
        'Floating mat',
        'Jet ski option',
      ],
      boatCta: 'Explore Boat Tour',
    },
    aboutCollab: {
      headline: 'Two Experiences. One Puerto Rico You’ll Never Forget.',
      description:
        'Sweet & Salty Puerto Rico and Blu Ocean Tours collaborate to offer complete Puerto Rico adventure experiences: a deep dive into the rainforest and an unforgettable escape into the Caribbean sea. Authentic, local, and premium.',
    },
    rainforestSection: {
      title: 'Sweet & Salty Rainforest Experience',
      description:
        'Explore El Yunque with local guides who know how to turn a visit into a real Puerto Rican adventure. Discover hidden waterfalls, natural pools, lush trails, and moments most tourists never get to experience.',
      features: [
        {
          title: 'Hidden Waterfalls',
          desc: 'Secret spots away from the crowds.',
        },
        {
          title: 'Natural Pools',
          desc: 'Dive into crystal-clear mountain waters.',
        },
        {
          title: 'Local Culture',
          desc: "Learn about the island's history and flora.",
        },
        {
          title: 'Small Groups',
          desc: 'Personalized attention and intimate vibe.',
        },
      ],
      cta: 'Book on WhatsApp',
    },
    bluOceanSection: {
      title: 'Blu Ocean Tours',
      description:
        'From Fajardo, Blu Ocean Tours takes you to discover Cayo Icacos and Palominos on a private boat experience designed for up to 6 guests. Enjoy music, snorkeling, drinks, snacks, floating mats, crystal-clear water, and optional jet ski fun.',
      features: [
        {
          title: 'Private Boat',
          desc: 'Exclusive for you and your group (up to 6).',
        },
        {
          title: 'Icacos + Palominos',
          desc: 'Visit the most beautiful eastern cays.',
        },
        {
          title: 'All Included',
          desc: 'Drinks, snacks, snorkel, and floating mat.',
        },
        {
          title: 'Jet Ski Option',
          desc: 'Add some adrenaline to your sea day.',
        },
      ],
      cta: 'Reserve Blu Ocean Tour',
    },
    whyBookUs: {
      title: 'Why Book With Us?',
      cards: [
        'Expert local guides',
        '100% private experiences',
        'Real Puerto Rico locations',
        'Perfect for tourists and locals',
        'Great for couples, families & birthdays',
        'Easy booking by WhatsApp or IG',
      ],
    },
    clientRatings: {
      title: 'How Our Clients Rate Us',
      subtitle:
        'Read the real reviews from travelers who already experienced each brand.',
      sweetSalty: 'Sweet & Salty Reviews',
      bluOcean: 'Blu Ocean Reviews',
    },
    packages: {
      title: 'Our Packages',
      rainforest: {
        title: 'Rainforest Experience',
        features: [
          'Private / small group option',
          'El Yunque rainforest',
          'Waterfalls and local experience',
        ],
        cta: 'Ask availability',
      },
      boat: {
        title: 'Blu Ocean Tours',
        features: [
          'Private boat tour',
          'Up to 6 guests',
          '5 hours',
          'Icacos + Palominos',
          'Drinks, snacks, snorkel, floating mat',
          'Jet ski option available',
        ],
        cta: 'Ask availability by WhatsApp',
      },
    },
    reviews: {
      title: 'What Our Guests Say',
      items: [
        'The best experience we had in Puerto Rico.',
        'Our guide made us feel safe, welcome, and amazed.',
        'Blu Ocean Tours was the highlight of our trip.',
        'Perfect day with friends, everything was included.',
      ],
    },
    faq: {
      title: 'Frequently Asked Questions',
      items: [
        {
          q: 'How do I book?',
          a: 'You can easily book by sending us a WhatsApp message or an Instagram DM.',
        },
        {
          q: 'Where do the tours depart from?',
          a: 'Boat tours depart from Fajardo. For the Rainforest, we will coordinate a meeting point in El Yunque.',
        },
        {
          q: 'Is it private?',
          a: 'Yes, Blu Ocean Tours is 100% private (up to 6 guests). Sweet & Salty offers both private and small group options.',
        },
        {
          q: 'What is included in the boat tour?',
          a: 'Boat, captain, drinks, snacks, snorkeling equipment, floating mat, music, beach umbrella, and floats.',
        },
        {
          q: 'Do I need experience for snorkeling or jet ski?',
          a: 'No! Our guides will teach you everything you need to know to enjoy safely.',
        },
        {
          q: 'What should I bring?',
          a: 'Swimsuit, towel, reef-safe sunscreen, sunglasses, and a great attitude.',
        },
      ],
    },
    finalCta: {
      headline: 'Your Puerto Rico Story Starts Here.',
      btnWhatsapp: 'Book on WhatsApp',
      btnInstagram: 'Message on Instagram',
      btnWebsite: 'View Blu Ocean Deals',
    },
    footer: {
      rights: 'All rights reserved.',
      locationBoat: 'Fajardo, Puerto Rico',
      locationRainforest: 'El Yunque, Puerto Rico',
    },
  },
}
